<!-- HEADER BOTONERA -->
<form [formGroup]='formData' (ngSubmit)="buscar(true)">
  <div class="card mt-2 mb-2 wow">
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="
        border-bottom: 1px solid #dee2e6;
        display: flex;
        align-items: center;
      ">
        <h4>Buscar descuentos</h4>
        <button type="button" mdbBtn color="info" (click)="abrirModalAgregarDescuento()" size="sm" mdbWavesEffect>
          Agregar
        </button>
      </div>

      <div class="filtros-body">
        <div class="row">
          <div class="col" style="
            display: flex;
            align-items: center;
            justify-content: center;
            padding-bottom: 2%;
          ">
            <strong>Buscar por: </strong>
            <!-- Material inline 1 -->
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="dctosEspeciales_rbBuscarPor_cliente"
                formControlName="buscarPor" [value]="TIPO_TIPO_CLIENTE" mdbInput (change)='limpiarBuscarPorCliente()' />
              <label class="form-check-label" for="dctosEspeciales_rbBuscarPor_cliente">Tipo cliente</label>
            </div>

            <!-- Material inline 2 -->
            <div class="form-check form-check-inline">
              <input type="radio" class="form-check-input" id="dctosEspeciales_rbBuscarPor_tipo_cliente"
                formControlName="buscarPor" [value]="TIPO_CLIENTE" mdbInput
                (change)='limpiarBuscarPorTiposClientes()' />
              <label class="form-check-label" for="dctosEspeciales_rbBuscarPor_tipo_cliente">Cliente</label>
            </div>

            <div class="col" *ngIf="formData.get('buscarPor').value === TIPO_CLIENTE" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" id="rutcliente" class="form-control" placeholder="" #rutcliente
                  formControlName="rutCliente" formatRut />
                <label for="rutcliente">RUT</label>
              </div>
            </div>

            <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
              (click)="abrirModalSeleccion()">
              <mdb-icon fas icon="search"></mdb-icon>
            </button>

            <ng-container *ngIf="formData.get('buscarPor').value === TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarClienteSeleccionados()" *ngIf="clientesSeleccionados?.length > 0">
                ({{clientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>
            <ng-container *ngIf="formData.get('buscarPor').value === TIPO_TIPO_CLIENTE">
              <button mdbBtn type="button" class="" color="info" mdbWavesEffect
                (click)="abrirModalSeleccionarTiposClienteSeleccionados()"
                *ngIf="tiposClientesSeleccionados?.length > 0">
                ({{tiposClientesSeleccionados.length | numerico}}) Seleccionados
              </button>
            </ng-container>




            <!-- <h6 class="text-info" *ngIf="clienteSeleccionado">
              {{ clienteSeleccionado.nombre }}
            </h6> -->
            <!-- <h6 class="text-info" *ngIf="clientesSeleccionados">
              {{ clientesSeleccionadosFormatted }}
            </h6> -->
            <!-- <h6 class="text-info" *ngIf="tiposClientesSeleccionados">
              {{ tiposClientesSeleccionadosFormatted }}
            </h6> -->
          </div>

          <div class="col">
            <div class="row">
              <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaInicio" [placeholder]="'Fecha inicio'" required
                    formControlName='fechaInicio'>
                  </mdb-date-picker>
                  <label for="fechaInicio">Desde:</label>

                  <!-- <div *ngIf="
                    formData.get('fechaInicio').invalid &&
                    (formData.get('fechaInicio').dirty ||
                    formData.get('fechaInicio').touched)
                  ">
                    <mdb-error *ngIf="formData.get('fechaInicio').hasError('required')">
                      Ingrese fecha inicio
                    </mdb-error>
                  </div> -->
                </div>
              </div>

              <!-- <div class="col-3">
                <div class="md-form">
                  <mdb-date-picker [inline]="true" name="fechaFinal" [placeholder]="'Fecha final'" required
                    formControlName='fechaFin'>
                  </mdb-date-picker>
                </div>
              </div> -->

              <div class="col" style="
               font-size: 14px;
               font-weight: bold;
               padding-top:1%">
                <span>Estados:</span>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" mdbInput id="EstActivo" [value]="RO_EstadoActivo"
                    formControlName="estadoAct" checked>
                  <label class="form-check-label" for="EstActivo">
                    Activo
                  </label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" mdbInput id="EstInactivo" [value]="RO_EstadoInactivo"
                    formControlName="estadoAct">
                  <label class="form-check-label" for="EstInactivo">
                    Inactivo
                  </label>
                </div>
              </div>


            </div>




          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-muted  filtros-footer justify-content-end" style="border-top: 1px solid #dee2e6;">
      <button mdbBtn type="button" color="info" size="sm" mdbWavesEffect (click)="limpiarfiltros()">
        <mdb-icon fas icon="broom"></mdb-icon>
        Limpiar
      </button>
      <button mdbBtn type="submit" size="sm" color="secondary" mdbWavesEffect>
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- LISTADO -->
<div class="card mb-2 wow">
  <div class="card-body" *ngIf="listaDescuentos">
    <table class="table table-striped table-hover table-sm align-middle">
      <thead class="grey lighten-2">
        <tr>
          <!-- <th scope="col">Código</th> -->
          <th scope="col">Descripción</th>
          <th scope="col">Desde</th>
          <th scope="col">Hasta</th>
          <th scope="col">Estado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="100%" style="text-align: center">
            <mdb-spinner spinnerColor="blue"></mdb-spinner>
          </td>
        </tr>
        <tr *ngIf="!loading && listaDescuentos?.length === 0">
          <td colspan="100%" style="text-align: center">
            No se encontró información
          </td>
        </tr>
        <tr *ngFor="let descuento of listaDescuentos; trackBy: trackByDescuentoCodigo">
          <!-- <td>{{ descuento.codigo }}</td> -->
          <td>{{ descuento.descripcion }}</td>
          <td>{{ descuento.fecha_inicio | fecha }}</td>
          <td>{{ descuento.fecha_termino | fecha }}</td>
          <td>
            <!-- <mdb-badge pill="true" success="true"
              *ngIf='descuento.activado
              && FechaActual
              <= descuento.fecha_termino
              '
              >Activo</mdb-badge> -->
            <mdb-badge pill="true" success="true" *ngIf='descuento.activado'>Activo</mdb-badge>

            <mdb-badge pill="true" danger="true" *ngIf='!descuento.activado'>Inactivo</mdb-badge>
            <!-- <mdb-badge pill="true" danger="true"
              *ngIf='descuento.activado && FechaActual > descuento.fecha_termino'>Inactivo</mdb-badge> -->

          </td>
          <td>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm" mdbTooltip="Ver"
              placement="right" (click)="ver(descuento)">
              <mdb-icon fas icon="eye"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Editar" placement="right" (click)="editar(descuento)"
              [disabled]="!descuento.permiteEdicion || !descuento.activado">
              <!-- [ngClass]="{'v-hidden': !descuento.permiteEdicion, 'v-visible': descuento.permiteEdicion}" -->
              <mdb-icon fas icon="pen"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Duplicar" placement="right" (click)="confirmDuplicar(descuento.codigo)">
              <mdb-icon far icon="copy"></mdb-icon>
            </button>
            <button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
              mdbTooltip="Desactivar" placement="right" (click)="confirmDesactivar(descuento.codigo)"
              [disabled]="!descuento.permiteEdicion || !descuento.activado">
              <mdb-icon fas icon="ban"></mdb-icon>
            </button>
          </td>
        </tr>
      </tbody>
      <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
        *ngIf="listaDescuentos?.length > 0"></app-pagination>
    </table>
  </div>
</div>

<!-- MODAL Agregar Descuento -->
<app-modal-addedit-descuentos [permiteUnidadNegocio]="permiteUnidadNegocio" (onSuccess)="onDescuentoSaved()">
</app-modal-addedit-descuentos>

<!-- MODAL seleccionarCliente -->
<app-modal-seleccionar-cliente (onSelectMultiple)="onClienteSeleccionadoMultiple($event)" queryType="ONLY_RUT"
  (onSelectSingle)="onClienteSeleccionado($event)">
</app-modal-seleccionar-cliente>
<app-modal-seleccionar-cliente-tipos (onSelectMultiple)="onClienteTiposSeleccionado($event)">
</app-modal-seleccionar-cliente-tipos>

<app-modal-confirm [title]="modalConfirmTitle" [contentText]="modalConfirmContent">
</app-modal-confirm>

<app-modal-show-clientes>
</app-modal-show-clientes>